import { StartAsPage } from "../components/types";
import { getEnv } from "@/env";
import type {
  AuthxLogistrationSplitData,
  AuthxLogistrationSplitVariant,
} from "@/monarch/rules/authxLogistrationSplit/types";

type BuildAuthxNavLogistrationUrlInput = {
  baseUrl: string;
  startAs: StartAsPage;
  authxVariant?: AuthxLogistrationSplitVariant;
  authxIsLoading: boolean;
  authxData?: AuthxLogistrationSplitData;
};

export const buildAuthxNavLogistrationUrl = ({
  baseUrl,
  startAs,
  authxVariant,
  authxIsLoading,
  authxData,
}: BuildAuthxNavLogistrationUrlInput): string => {
  // Return base URL while loading to avoid flash of incorrect URL
  if (authxIsLoading) {
    return baseUrl;
  }
  const isAuthxEnabled = authxVariant === "authx";

  if (!isAuthxEnabled) {
    return baseUrl;
  }

  // Resolve landing pages from Monarch with sensible fallbacks
  const authxPages = {
    loginLandingPage: authxData?.loginLandingPage ?? "/authx/learning",
    registerLandingPage: authxData?.registerLandingPage ?? "/authx/for-you",
  };

  const landingPage =
    startAs === StartAsPage.Register
      ? authxPages.registerLandingPage
      : authxPages.loginLandingPage;

  const siteUrl = getEnv("NEXT_PUBLIC_SITE_URL");
  const parsed = new URL(baseUrl, siteUrl);
  const absoluteLandingPage = new URL(landingPage, siteUrl).toString();
  parsed.searchParams.set("next", absoluteLandingPage);
  return parsed.toString();
};
